import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WebApiPublications } from '@shared/enums/routes';
import {
  PublicationCategoryResponse,
  PublicationSearchRequest,
  PublicationSearchResponse,
  PublicationTagResponse,
} from '../types/publications.types';
import { parseObjectToUrlParams } from '@shared/utils/utils';

@Injectable()
export class PublicationsDatasourceService {
  constructor(private http: HttpClient) {}

  getCategories(): Observable<PublicationCategoryResponse[]> {
    return this.http.get<PublicationCategoryResponse[]>(
      WebApiPublications.Categories
    );
  }

  getTags(): Observable<PublicationTagResponse[]> {
    return this.http.get<PublicationTagResponse[]>(WebApiPublications.Tags);
  }

  searchPublications(
    body: PublicationSearchRequest
  ): Observable<PublicationSearchResponse> {
    return this.http.get<PublicationSearchResponse>(WebApiPublications.Search, {
      params: parseObjectToUrlParams(body),
    });
  }
}
